import AuthSignOutRedirect from '@components/Auth/SignOut/Redirect'

const SignOutPage = () => <AuthSignOutRedirect />

export default SignOutPage
